import { render, staticRenderFns } from "./callMe_mobile.vue?vue&type=template&id=155c4ba0&scoped=true&"
import script from "./callMe_mobile.vue?vue&type=script&lang=js&"
export * from "./callMe_mobile.vue?vue&type=script&lang=js&"
import style0 from "./callMe_mobile.vue?vue&type=style&index=0&id=155c4ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c4ba0",
  null
  
)

export default component.exports